import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Divider = styled(Box)(({ theme }) => ({
  height: 1,
  backgroundColor: theme.palette?.gray30?.main,
}));

export const StyledBox = styled(Box)<{ isMobile: boolean }>(({ isMobile }) => ({
  width: isMobile ? "auto" : 534,
  padding: "36px 24px",
}));

export const Title = styled(Box)(() => ({
  textAlign: "center",
  fontSize: 34,
  fontWeight: 400,
  letterSpacing: 0.25,
}));

export const Organizer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
}));

export const CreatedAtOrganizer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

export const PeriodContainer = styled(Box)<{ isMobile: boolean }>(({ isMobile }) => ({
  height: isMobile ? "auto" : 52,
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  fontSize: "16px",
  lineHeight: "24px",
  letterSpacing: "0.44px",
}));
